export default __webpack_public_path__ + "static/1771-8477970fd2e7b8f585f753bb82776cbf.gif";